function calcolaDataConsegna(giorni) {
  const element = document.getElementById("consegna");
  const date = new Date();
  date.setDate(date.getDate() + giorni);
  const option =  { day: 'numeric', month: 'long', year: 'numeric' };
  const formattedDate = date.toLocaleDateString("it-IT", option);
  
  element.textContent = "La consegna è prevista per il giorno: ";
  let span = document.createElement("span");
  span.textContent = formattedDate;
  element.appendChild(span);
}

window.addEventListener("load", function () {
  if (window.location.href.includes("products")) {
    const giorni = parseInt(document.getElementById("consegna").getAttribute("data-giorni"), 10);
    calcolaDataConsegna(giorni);

    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      document.querySelectorAll("quantity-selector").forEach((selector) => { 
        selector.append(document.getElementById("consegna"));
      });
    }
  }
});

window.addEventListener("resize", function () {
  if (window.location.href.includes("products")) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const isMobile = window.innerWidth <= 768;
      if (isMobile) {
        document.querySelectorAll("quantity-selector").forEach((selector) => { 
          selector.append(document.getElementById("consegna"));
        });  
      } else {
        document.querySelector(".product-form__action-wrapper").append(document.getElementById("consegna"));
      }
    }, 100);
  }
});




/* document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function() {
        var prezzoElement = document.querySelector(".messagebox");

        prezzoElement.classList.add("visible");
    }, 1300);
}); */

 

document.querySelectorAll('a[href^="#"]:not(.request-quote-mobile_link)').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
        e.preventDefault();
        
        const targetElement = document.querySelector(this.getAttribute('href'));
        window.scrollTo({
            top: targetElement.offsetTop,
            behavior: 'smooth'
        });
    });
}); 